// Mind2Magic CRM — Selection Mode
// Extracted from index.html inline script (Phase 1, Step 2).
// Bulk selection, drag selection, mass stage/responsable changes.

import { store } from './store.js'

// ========== LOCAL STATE (module-scoped) ==========
let selectedLeads = new Set();
let isDragging = false;
let dragStartX = 0, dragStartY = 0;
let selectionBox = null;


// ========== SELECTION MODE ==========

function toggleSelectAll() {
    store.selectionMode = !store.selectionMode;
    if (store.selectionMode) {
        document.getElementById('btnSelectAll').textContent = '☑ Todo';
        document.getElementById('btnSelectAll').classList.add('active');
        document.getElementById('selectedCount').style.display = 'inline';
        document.getElementById('bulkResponsable').style.display = 'inline';
        document.getElementById('bulkEtapa').style.display = 'inline';
        document.getElementById('btnCancelSelect').style.display = 'inline';
        // Poblar dropdown responsable
        const opts = store.team.map(t => `<option value="${t.nombre}">${t.nombre}</option>`).join('');
        document.getElementById('bulkResponsable').innerHTML = '<option value="">Asignar a...</option>' + opts;
        // Poblar dropdown etapas
        const etapaOpts = STAGES.map(s => `<option value="${s.id}">${s.name}</option>`).join('');
        document.getElementById('bulkEtapa').innerHTML = '<option value="">Mover a etapa...</option>' + etapaOpts;
        // Re-render pipeline para mostrar botones de columna
        renderPipeline();
    } else {
        selectAllVisible();
    }
    updateSelectionCount();
}

function selectAllVisible() {
    document.querySelectorAll('.card.selectable').forEach(card => {
        selectedLeads.add(card.dataset.id);
        card.classList.add('selected');
    });
    updateSelectionCount();
}

function selectColumn(stageId) {
    const column = document.querySelector(`.col-cards[data-stage="${stageId}"]`);
    if (!column) return;
    column.querySelectorAll('.card').forEach(card => {
        selectedLeads.add(card.dataset.id);
        card.classList.add('selected');
    });
    updateSelectionCount();
}

function setupSelectionMode() {
    const pipeline = document.getElementById('pipeline');
    if (pipeline) pipeline.classList.add('selecting');

    document.querySelectorAll('.card').forEach(card => {
        card.classList.add('selectable');
    });
    setupDragSelection();
}

// Drag selection - arrastrar para seleccionar múltiples
function setupDragSelection() {
    const pipeline = document.getElementById('pipeline');
    if (!pipeline) return;

    // Remover listeners anteriores para evitar duplicados
    pipeline.removeEventListener('mousedown', startDragSelection);
    document.removeEventListener('mousemove', updateDragSelection);
    document.removeEventListener('mouseup', endDragSelection);

    pipeline.addEventListener('mousedown', startDragSelection);
    document.addEventListener('mousemove', updateDragSelection);
    document.addEventListener('mouseup', endDragSelection);
}

let dragStartCard = null;

function startDragSelection(e) {
    if (!store.selectionMode) return;
    if (e.target.closest('button')) return;

    // Prevenir selección de texto
    e.preventDefault();

    isDragging = true;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    dragStartCard = e.target.closest('.card');
}

function updateDragSelection(e) {
    if (!isDragging) return;

    // Create selection box on first real move (avoids flash on click)
    if (!selectionBox) {
        const dx = Math.abs(e.clientX - dragStartX);
        const dy = Math.abs(e.clientY - dragStartY);
        if (dx < 5 && dy < 5) return;
        selectionBox = document.createElement('div');
        selectionBox.className = 'selection-box';
        document.body.appendChild(selectionBox);
    }

    // Prevenir selección de texto mientras arrastra
    e.preventDefault();

    const x = Math.min(e.clientX, dragStartX);
    const y = Math.min(e.clientY, dragStartY);
    const w = Math.abs(e.clientX - dragStartX);
    const h = Math.abs(e.clientY - dragStartY);

    selectionBox.style.left = x + 'px';
    selectionBox.style.top = y + 'px';
    selectionBox.style.width = w + 'px';
    selectionBox.style.height = h + 'px';

    // Detectar cards dentro del rectángulo
    const boxRect = { left: x, top: y, right: x + w, bottom: y + h };
    document.querySelectorAll('.card.selectable').forEach(card => {
        const cardRect = card.getBoundingClientRect();
        const intersects = !(cardRect.right < boxRect.left || cardRect.left > boxRect.right || cardRect.bottom < boxRect.top || cardRect.top > boxRect.bottom);
        if (intersects) {
            selectedLeads.add(card.dataset.id);
            card.classList.add('selected');
        }
    });
    updateSelectionCount();
}

function endDragSelection(e) {
    if (!isDragging) return;
    const dx = Math.abs(e.clientX - dragStartX);
    const dy = Math.abs(e.clientY - dragStartY);
    const wasClick = dx < 5 && dy < 5;

    if (selectionBox) {
        selectionBox.remove();
        selectionBox = null;
    }
    isDragging = false;

    // If barely moved, treat as click → toggle the card
    if (wasClick && dragStartCard) {
        toggleCardSelection(dragStartCard.dataset.id);
    }
    dragStartCard = null;
}

function toggleCardSelection(id) {
    const card = document.querySelector(`.card[data-id="${id}"]`);
    if (selectedLeads.has(id)) {
        selectedLeads.delete(id);
        card?.classList.remove('selected');
    } else {
        selectedLeads.add(id);
        card?.classList.add('selected');
    }
    updateSelectionCount();
}

function updateSelectionCount() {
    document.getElementById('selectedCount').textContent = `${selectedLeads.size} seleccionados`;
    const mergeBtn = document.getElementById('btnMergeSelected')
    if (mergeBtn) mergeBtn.style.display = selectedLeads.size === 2 ? 'inline' : 'none'
    const watchBtn = document.getElementById('btnWatchSelected')
    if (watchBtn) watchBtn.style.display = selectedLeads.size > 0 ? 'inline' : 'none'
    const deleteBtn = document.getElementById('btnDeleteSelected')
    if (deleteBtn) deleteBtn.style.display = selectedLeads.size > 0 ? 'inline' : 'none'
}

function mergeSelectedLeads() {
    if (selectedLeads.size !== 2) { window.toast('Selecciona exactamente 2 leads para fusionar', 'warning'); return }
    const [idA, idB] = [...selectedLeads]
    cancelSelection()
    window.manualMerge(idA, idB)
}

function cancelSelection() {
    store.selectionMode = false;
    selectedLeads.clear();
    isDragging = false;
    if (selectionBox) { selectionBox.remove(); selectionBox = null; }

    const pipeline = document.getElementById('pipeline');
    if (pipeline) pipeline.classList.remove('selecting');

    document.getElementById('btnSelectAll').textContent = '☑ Seleccionar';
    document.getElementById('btnSelectAll').classList.remove('active');
    document.getElementById('selectedCount').style.display = 'none';
    document.getElementById('bulkResponsable').style.display = 'none';
    document.getElementById('bulkEtapa').style.display = 'none';
    document.getElementById('btnCancelSelect').style.display = 'none';
    const watchBtn = document.getElementById('btnWatchSelected');
    if (watchBtn) watchBtn.style.display = 'none';
    const deleteBtn = document.getElementById('btnDeleteSelected');
    if (deleteBtn) deleteBtn.style.display = 'none';
    document.querySelectorAll('.card').forEach(card => {
        card.classList.remove('selectable', 'selected');
        card.onclick = () => openLead(card.dataset.id);
    });
    renderPipeline(); // Re-render para quitar botones de columna
}

function bulkChangeResponsable(resp) {
    if (!resp || selectedLeads.size === 0) return;
    saveState('cambio masivo responsable');
    selectedLeads.forEach(id => {
        const l = store.leads.find(l => l.id === id);
        if (l) {
            l.responsable = resp;
            const c = store.clients[l.clientKey];
            if (c) { const t = c.trips.find(t => t.id === id); if (t) t.responsable = resp; }
        }
    });
    toast(`${selectedLeads.size} leads asignados a ${resp}`, 'success');
    cancelSelection();
    renderPipeline();
}

function bulkChangeEtapa(stageId) {
    if (!stageId || selectedLeads.size === 0) return;
    saveState('cambio masivo etapa');
    const stageName = STAGES.find(s => s.id === stageId)?.name || stageId;
    const newProgress = calcProgress(stageId);

    selectedLeads.forEach(id => {
        const l = store.leads.find(l => l.id === id);
        if (l) {
            l.stage = stageId;
            l.progress = newProgress;
            const c = store.clients[l.clientKey];
            if (c) {
                const t = c.trips.find(t => t.id === id);
                if (t) { t.stage = stageId; t.progress = newProgress; }
            }
        }
    });
    toast(`${selectedLeads.size} leads movidos a "${stageName}"`, 'success');
    cancelSelection();
    renderPipeline();
}


function bulkToggleWatch() {
    if (selectedLeads.size === 0) return
    window.saveState('cambio masivo seguimiento')
    let addedCount = 0, removedCount = 0
    selectedLeads.forEach(id => {
        const l = store.leads.find(l => l.id === id)
        if (l) {
            if (!l.formData) l.formData = {}
            if (l.formData.watched) {
                l.formData.watched = false
                removedCount++
            } else {
                l.formData.watched = true
                addedCount++
            }
            window.syncLeadToSupabase?.(l)
        }
    })
    if (addedCount > 0) window.toast(`${addedCount} leads agregados a Seguimiento`, 'success')
    if (removedCount > 0) window.toast(`${removedCount} leads removidos de Seguimiento`, 'info')
    cancelSelection()
    window.renderAll?.()
}

// --- Bulk Delete ---

function confirmBulkDelete() {
    if (selectedLeads.size === 0) return
    const count = selectedLeads.size
    const msg = `¿Eliminar ${count} lead${count > 1 ? 's' : ''} permanentemente?`
    document.getElementById('bulkDeleteMessage').textContent = msg
    window.openModal('bulkDeleteModal')
}

function executeBulkDelete() {
    if (selectedLeads.size === 0) return
    const { leads, historico, clients } = store
    const count = selectedLeads.size

    window.saveState('borrado masivo')

    selectedLeads.forEach(id => {
        let idx = leads.findIndex(l => l.id === id)
        let arr = leads
        if (idx === -1) { idx = historico.findIndex(l => l.id === id); arr = historico; }
        if (idx === -1) return

        const l = arr[idx]
        const c = clients[l.clientKey]
        if (c) {
            const ti = c.trips.findIndex(t => t.id === id)
            if (ti !== -1) c.trips.splice(ti, 1)
            if (!c.trips.length) { window.supabaseDB?.deleteClient(l.clientKey); delete clients[l.clientKey] }
        }

        if (l._supabaseId) {
            window.supabaseDB?.deleteLead(l._supabaseId)
            store._recentSyncs.add(l._supabaseId)
            setTimeout(() => store._recentSyncs.delete(l._supabaseId), 15000)
        } else {
            const suppressKey = `del_${(l.titular || '').toLowerCase()}_${l.phone || ''}`
            store._recentSyncs.add(suppressKey)
            setTimeout(() => store._recentSyncs.delete(suppressKey), 15000)
        }

        arr.splice(idx, 1)
    })

    window.closeModal('bulkDeleteModal')
    window.toast(`${count} lead${count > 1 ? 's' : ''} eliminado${count > 1 ? 's' : ''}`, 'success')
    cancelSelection()
    window.renderAll()
}


// ========== WINDOW BRIDGE ==========
Object.assign(window, {
    toggleSelectAll,
    selectColumn,
    setupSelectionMode,
    cancelSelection,
    bulkChangeEtapa,
    bulkChangeResponsable,
    mergeSelectedLeads,
    bulkToggleWatch,
    confirmBulkDelete,
    executeBulkDelete,
});
